import APIService from '../api';

class AuthorizationService extends APIService {
  private requiresTokenRefresh = true;

  public async userIsValid(): Promise<boolean> {
    return new Promise(resolve => {
      resolve(!!APIService.token);
    });
  }

  public userIsValidNotRefresh() {
    return !!APIService.token;
  }

  public async switchToken(businessManager?: string) {
    try {
      const { data } = await this.post('/auth/v2/switch-token/manager', {
        businessManager
      });
      const { access_token } = data;

      return access_token;
    } catch (e) {
      return false;
    }
  }

  public changeToken(authType: string) {
    return this.get<{ access_token: string }>(`/auth/switch-token/${authType}`);
  }
}

export default AuthorizationService;
